'use client'

import { createContext, useContext, ReactNode } from 'react'
import { translations, type TKey } from '@/lib/translations'

interface LangContextType {
  t: (key: TKey) => string
}

const LangContext = createContext<LangContextType | null>(null)

export function LangProvider({ children }: { children: ReactNode }) {
  const t = (key: TKey): string => translations[key] ?? key
  return (
    <LangContext.Provider value={{ t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() {
  const ctx = useContext(LangContext)
  if (!ctx) throw new Error('useLang must be used within LangProvider')
  return ctx
}
